import { render, staticRenderFns } from "./AddLitterSale.vue?vue&type=template&id=983d2278&scoped=true&"
import script from "./AddLitterSale.vue?vue&type=script&lang=js&"
export * from "./AddLitterSale.vue?vue&type=script&lang=js&"
import style0 from "./AddLitterSale.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AddLitterSale.vue?vue&type=style&index=1&id=983d2278&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "983d2278",
  null
  
)

export default component.exports